<div class='header'>
    <div>
        <h2 class='headline-2'>{{'Hello' | translate }} {{ authService.user()?.displayName }}</h2>
        <p>{{'PleaseSelectExistingOrNewContract' | translate }}</p>
    </div>
    <button mat-button mat-flat-button color="primary" (click)="newContract()">
        + {{'NewContract' | translate }}
    </button>
</div>
<div class="controls">
    <mat-form-field>
        <input [formControl]="searchFormControl" type="text" matInput placeholder="{{'SearchByContractName' | translate }}">
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-form-field>
        <mat-label>{{'Filter' | translate }}</mat-label>
        <mat-select [formControl]="statusFormControl">
            <mat-option [value]="0">{{'AllContracts' | translate }} ({{this.contractStatuses().all}})</mat-option>
            <mat-option [value]="2">{{'Yes' | translate }} ({{this.contractStatuses().yes}})</mat-option>
            <mat-option [value]="3">{{'No' | translate }} ({{this.contractStatuses().no}})</mat-option>
            <mat-option [value]="4">{{'ToBeChecked' | translate }} ({{this.contractStatuses().check}})</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field>
        <mat-label>{{'Sort' | translate }}</mat-label>
        <mat-select [formControl]="sortFormControl">
            <mat-option [value]="1">{{'CurrentFirst' | translate }}</mat-option>
            <mat-option [value]="2">{{'OldestFirst' | translate }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div class="content">
    @for (workflow of subscriptionOverview.workflowOverviewFiltered(); track workflow) {
    <contract-tile [contract]="workflow" />
    }@empty {
    <span class="no-contracts">{{'NoContracts' | translate }}</span> }
</div>

<div class="footer">
    <mat-paginator [length]="subscriptionOverview.workflowOverview().length" [pageSizeOptions]="[2, 5, 10, 20, 50]" [pageSize]="subscriptionOverview.numContractsPerPage()" (page)="subscriptionOverview.pageEvent.set($event)" aria-label="Select page" />
</div>